export enum AgentPairingType {
  None = "None",
  ProNumber = "ProNumber",
  Barcode = "Barcode"
}
